import { render, staticRenderFns } from "./NewCard.vue?vue&type=template&id=008f7bbd&"
import script from "./NewCard.vue?vue&type=script&lang=js&"
export * from "./NewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports